export const LOAD_NOTICES = 'LOAD_NOTICES'


